export default [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: (r) => require(['@/child/common/views/login/Login.vue'], r)
    // component: (r) => require(['@/child/common/views/login/CommonLogin.vue'], r)
  }
]
